module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/electricity infrastructure-9e7f0916c4a530c777f92aa168cf220c.png";